import { useEffect, useState, Dispatch, SetStateAction } from 'react';

export const useCountdown = (): [number, Dispatch<SetStateAction<number>>] => {
  const [countdown, setCountdown] = useState<number>(0);

  useEffect(() => {
    if (countdown === 0) {
      return;
    }

    const timeout = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [countdown]);

  return [countdown, setCountdown];
};
